export default ["DONE", "UNDONE", "EXEMPT", "SUSPENDED"];
